import { BlackjackStylesType } from '../../model/blackjack-types';
import { GameServices } from '../../services/game-services';
import { CroupierHandViewModel } from './croupier-hand-view-model';

export class CroupierBettingBoxViewModel {
  public get borderColor() {
    return this.gameServices.gameThemeService.getNumericalRGB(BlackjackStylesType.BorderColor);
  }
  public get borderAlpha() {
    return this.gameServices.gameThemeService.getNumericalAlpha(BlackjackStylesType.BorderColor);
  }

  public readonly croupierHandViewModel: CroupierHandViewModel;

  constructor(private gameServices: GameServices) {
    this.croupierHandViewModel = new CroupierHandViewModel(gameServices);
  }

  public resetGameScene() {
    this.croupierHandViewModel.resetGameScene();
  }
}
